<template>
  <div class="pageNav">
    <ul>
      <li>
        <a href="#">
          <FontAwesomeIcon :icon="['fas', 'angle-double-left']" />
        </a>
      </li>
      <li v-for="i in 5" :key="i">
        <a href="#">{{ i }}</a>
      </li>
      <li>
        <a href="#">
          <FontAwesomeIcon :icon="['fas', 'angle-double-right']" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    FontAwesomeIcon,
  },
  setup() {
    library.add(faAngleDoubleLeft)
    library.add(faAngleDoubleRight)
  },
}
</script>

<style scoped>
.pageNav {
  margin: 25px 0 0;
  height: 50px;
}
.pageNav ul {
  background: url('../../assets/images/plate.png') no-repeat 50% 0;
  background-size: contain;
  list-style: none;
  font-size: 0;
  text-align: center;
  height: inherit;
}
.pageNav li {
  display: inline-block;
  line-height: 50px;
  margin: 0 10px;
}
.pageNav li a {
  color: #000;
  font-size: 20px;
  font-weight: 700;
  background: rgba(0, 0, 0, 1);
  text-shadow: 0 0 0.1em rgba(255, 255, 255, 1),
    0.01em 0.02em 0.02em rgba(255, 255, 255, 1);
  -webkit-background-clip: text;
}
</style>
